import { useOperatorData } from './OperatorDataContext';

/**
 * MerchantProvider - DEPRECATED
 *
 * This component is no longer needed as merchant data is now managed by OperatorDataProvider.
 * It's kept here for backward compatibility but does nothing.
 *
 * @deprecated Use OperatorDataProvider instead
 */
export function MerchantProvider({ children }) {
  return children;
}

/**
 * Hook to access merchant context
 *
 * This is now a wrapper around useOperatorData for backward compatibility.
 * All merchant data is managed by OperatorDataProvider.
 *
 * @returns {Object} Context object with merchant data
 * @property {number|null} merchantId - Currently selected merchant ID
 * @property {Object|null} merchant - Currently selected merchant object
 * @property {Function} setCurrentMerchant - Function to set current merchant
 * @property {Function} resetMerchant - Function to reset merchant selection
 * @property {Array} merchants - List of available merchants
 * @property {boolean} loading - Loading state for merchants
 * @property {string|null} error - Error message if loading failed
 *
 * @example
 * const { merchantId, merchant, setCurrentMerchant, resetMerchant, merchants, loading, error } = useMerchant();
 */
export function useMerchant() {
  const operatorData = useOperatorData();
  return {
    merchantId: operatorData.merchantId,
    merchant: operatorData.merchant,
    setCurrentMerchant: operatorData.setCurrentMerchant,
    resetMerchant: operatorData.resetMerchant,
    merchants: operatorData.merchants,
    loading: operatorData.loading,
    error: operatorData.error,
  };
}
